import axios from 'axios'

class GoogleCustomSearch {
  private apiKey: string
  private searchEngine: string
  public searchURL: string
  public keywords: string
  public website: string
  public numberOfResults: number
  public startFrom: number
  public language: string

  constructor(
    keywords: string,
    website: string,
    language: string,
    startFrom: number = 1,
    numberOfResults: number
  ) {
    this.apiKey = process.env.GATSBY_GOOGLE_CUSTOM_SEARCH_API_KEY as string
    this.searchEngine = process.env.GOOGLE_CUSTOM_SEARCH_ENGINE_ID as string
    this.searchURL = process.env.GATSBY_GOOGLE_CUSTOM_SEARCH_URL as string
    this.keywords = keywords
    this.website = website
    this.language = language
    this.numberOfResults = numberOfResults || 10
    this.startFrom = startFrom
  }

  async fetchResults() {
    let searchResults: any = {
      totalResults: 0,
      searchResults: [],
    }

    try {
      let results: any

      if (this.keywords && this.keywords.trim().length >= 3) {
        const vertexAIURL = `${this.searchURL}?key=${this.apiKey}`
        const requestBody: any = {
          query: this.keywords,
          pageSize: this.numberOfResults,
          offset: this.startFrom.toString(),
        }

        if (this.website !== 'all') {
          requestBody.filter = `siteSearch:"${this.website}"`
        }
        results = await axios.post(vertexAIURL, requestBody)
      }

      if (results && results.data && results.data.results && results.data.results.length > 0) {
        searchResults = {
          totalResults: results.data.totalSize,
          searchResults: results.data.results,
        }
      } else {
        searchResults = {
          totalResults: 0,
          searchResults: [],
        }
      }
    } catch (error: any) {
      console.log('Something went wrong:', error.message)
    }

    return searchResults
  }
}

export default GoogleCustomSearch
